var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkype = function SvgSkype(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M11.623 13.545a4.63 4.63 0 0 1-3.61-.11 2.15 2.15 0 0 1-1.202-1.726.707.707 0 0 1 1.14-.502c.297.298.329.643.625 1.02.625.894 2.875.674 2.922-.519.015-.518-.422-.8-.86-.941-1.37-.408-3.636-.502-3.666-2.401.015-1.539 1.593-2.025 2.952-2.025A2.96 2.96 0 0 1 12.58 7.52c.516.91-.329 1.585-.966 1.146-.359-.33-.374-.722-.828-1.052-.578-.408-2.265-.33-2.343.628 0 .894 1.734.925 2.921 1.333a2.04 2.04 0 0 1 1.736 1.881 2.03 2.03 0 0 1-1.477 2.09m4.343-2.605a6.25 6.25 0 0 0-1.76-5.36 6.18 6.18 0 0 0-5.344-1.734 3.56 3.56 0 0 0-5.848 2.396c-.077.87.17 1.738.692 2.438a6.26 6.26 0 0 0 1.674 5.745 6.2 6.2 0 0 0 5.717 1.696A3.562 3.562 0 0 0 17 13.396a3.56 3.56 0 0 0-1.03-2.456z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkype);
export default ForwardRef;